// Shared taxonomy for the Documents tab category chips.
// Kept out of Portal.jsx / DocumentsTab.jsx so testing agents can import & assert against it if needed.
export const DOC_CATEGORIES = [
  { v: "all", label: "All folders", match: () => true },
  { v: "income", label: "Income", match: (dt) => /^(W-?2|1099-|SSA-1099|K-1)/i.test(dt || "") },
  { v: "deductions", label: "Deductions & credits", match: (dt) => /^(1098|8862|8880|receipts?|charitable)/i.test(dt || "") },
  { v: "business", label: "Business & books", match: (dt) => /(trial|tb|bank|invoice|k-1_out|schedule\s?c|schedule\s?e|schedule\s?f|4562|equipment|payroll|1120|1065)/i.test(dt || "") },
  { v: "compliance", label: "Compliance & IRS", match: (dt) => /^(engagement|consent|7216|irs|form\s?8867|foreign|fbar|8938|5471|8865|1040nr)/i.test(dt || "") },
  { v: "prior_year", label: "Prior year", match: (dt) => /^(py_|prior|last\s?year)/i.test(dt || "") },
];

// Entity-hint -> compatible portfolio entity types (used to suggest moving a document to a sibling entity).
export const HINT_TO_TYPES = {
  individual: ["Individual"],
  partnership: ["Partnership", "LLC"],
  s_corp: ["S-Corp"],
  c_corp: ["C-Corp"],
  nonprofit: ["Non-profit"],
  trust: ["Trust"],
};
